import { FC, useRef } from "react";
import { Stack } from "@mui/material";
import { useAppSelector } from "../../../../../../../store/hooks";
import { billingExplorerSummaryDataSelector } from "../../../../../../../store/resource-explorer/selectors/resource-explorer-summary/billingExplorerSummaryDataSelector";
import { anomaliesHtmlStyle } from "@/components/common/explain-with-ai-drawer/components/body/components/utils/constants";

interface BillingExplorerExplainWithAiSummaryProps {
  index: number;
}
export const BillingExplorerExplainWithAiSummary: FC<
  BillingExplorerExplainWithAiSummaryProps
> = ({ index }) => {
  const summary = useAppSelector((state) =>
    billingExplorerSummaryDataSelector(state, index),
  );
  const contentRef = useRef<HTMLDivElement | null>(null);

  return (
    <Stack
      ref={contentRef}
      overflow="auto"
      dangerouslySetInnerHTML={{ __html: summary ?? "" }}
      sx={anomaliesHtmlStyle}
    />
  );
};
